import { Panel } from "@mixitone/components/Controls";
import { ApplicationView } from "@mixitone/mvc";
import React from "react";
import { DashLayout } from "../../Components/DashLayout";
import { MessageBanner } from "../../Components/MessageBanner";
import { CompetitionsList } from "./components/CompetitionsList";
import { PlayerCompetitionsPageController } from "./controllers/PlayerCompetitionsPageController";

const ControlledPlayerCompetitionsPage: React.FC = () => {
  const controller = PlayerCompetitionsPageController.use();
  const { loading, error, currentAndFutureRegistrations, pastRegistrations, sortBy, filterBy } =
    controller.state;

  if (loading) {
    return (
      <DashLayout title="My tournaments">
        <div className="flex flex-col gap-6 pb-6">
          <div className="animate-pulse">
            <div className="h-10 mb-4 rounded bg-slate-200"></div>
            <div className="h-20 mb-2 rounded bg-slate-200"></div>
            <div className="h-20 mb-2 rounded bg-slate-200"></div>
          </div>
        </div>
      </DashLayout>
    );
  }

  const count = currentAndFutureRegistrations.length + pastRegistrations.length;

  return (
    <DashLayout title="My tournaments">
      <div className="flex flex-col gap-6 pb-6">
        {error && (
          <MessageBanner message={error} type="error" onClose={() => controller.actionClearError()} />
        )}

        {count === 0 ? (
          <Panel title="No tournaments" titleClassName="font-semibold">
            <p className="text-slate-600">You haven't entered any tournament competitions yet.</p>
          </Panel>
        ) : (
          <>
            <CompetitionsList title="Upcoming tournaments" registrations={currentAndFutureRegistrations} />
            {pastRegistrations.length > 0 && (
              <div className="mt-6">
                <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:items-center sm:justify-between">
                  <h2 className="text-lg font-semibold">Past tournaments</h2>
                  <div className="flex flex-wrap items-center gap-2">
                    <label className="text-sm text-slate-600">Filter:</label>
                    <select
                      value={filterBy}
                      onChange={(e) =>
                        controller.actionSetFilterBy(e.target.value as "all" | "singles" | "doubles")
                      }
                      className="px-3 py-1 text-sm bg-white border rounded-md border-slate-300 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    >
                      <option value="all">All</option>
                      <option value="singles">Singles</option>
                      <option value="doubles">Doubles</option>
                    </select>
                    <label className="ml-2 text-sm text-slate-600">Sort:</label>
                    <select
                      value={sortBy}
                      onChange={(e) =>
                        controller.actionSetSortBy(e.target.value as "date" | "competition" | "placement")
                      }
                      className="px-3 py-1 text-sm bg-white border rounded-md border-slate-300 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    >
                      <option value="date">Date</option>
                      <option value="competition">Competition</option>
                      <option value="placement">Placement</option>
                    </select>
                  </div>
                </div>
                <CompetitionsList
                  title=""
                  registrations={pastRegistrations}
                  emptyMessage="No past tournaments match your filters."
                />
              </div>
            )}
          </>
        )}
      </div>
    </DashLayout>
  );
};

const PlayerCompetitionsPage = PlayerCompetitionsPageController.scope(
  ApplicationView(ControlledPlayerCompetitionsPage),
);

export { PlayerCompetitionsPage };
